import React from 'react';
import PropTypes from 'prop-types';
import css from './CustomAIDimension.css';
import { Icon } from '../../components/widgets';
import { IconSizes, IconVariants } from '../../components/foundations/Icon';
import EditableTitle from '../../components/widgets/EditableTitle';

const CustomAIDimensionHeader = ({ customAIDimension, onDelete, onNameChange, isExpanded }) => {
    const isNew = !customAIDimension.id;
    const displayName = customAIDimension.display_name || '';

    return (
        <div className={css.header}>
            {!isExpanded ? (
                <span className={css.displayName}>{displayName}</span>
            ) : (
                <EditableTitle value={displayName} placeholder="e.g. Discount Display" onTextChanged={onNameChange} />
            )}
            {!isNew && (
                <Icon
                    name="trash"
                    size={IconSizes.SMALL}
                    variant={IconVariants.LIGHT}
                    onClick={e => {
                        e.stopPropagation();
                        onDelete();
                    }}
                />
            )}
        </div>
    );
};

CustomAIDimensionHeader.propTypes = {
    customAIDimension: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        app: PropTypes.string,
        description: PropTypes.string,
        display_name: PropTypes.string,
        media_type: PropTypes.number,
        valueType: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.string),
    }),
    onDelete: PropTypes.func,
    onNameChange: PropTypes.func,
    isExpanded: PropTypes.bool,
};

export default CustomAIDimensionHeader;
